import { format } from 'date-fns';
import { generateAamvaPartDaqBadgeNumber } from './generateAamvaPartDaqBadgeNumber';
export function generateAamvaDataForAccountBadge(context, accountBadgeData, account, options) {
    if (!accountBadgeData.accountBadgeNumericId && accountBadgeData.accountBadgeNumericId !== 0) {
        throw new Error('Invalid data - accountBadgeNumericId should exist');
    }
    return {
        ansiHeaderData: Object.assign({ badgeIssuerId: options.badgeIssuerId.toString().padStart(6, '0').slice(0, 6), aamvaVersionMajor: '03', aamvaVersionMinor: '00', aamvaSubfilesCount: '01' }, options.headerOverrides),
        dajState: options.stateFullName,
        dakZipCode: undefined,
        daqBadgeNumber: generateAamvaPartDaqBadgeNumber(context, Object.assign({ stateId: options.stateId.slice(0, 2), issuanceNo: options.issuanceNo, badgeIssuerId: options.badgeIssuerId, badgeVersion: options.badgeVersion, cardId: accountBadgeData.accountBadgeNumericId }, options.badgeNumberOverrides)),
        dayEyeColor: 'UNK',
        dbbDateOfBirth: undefined,
        dbcGender: undefined,
        dauHeight: undefined,
        dbaExpirationDate: format(new Date(accountBadgeData.expiresAt), 'yyyy-MM-dd'),
        dbdIssueDate: format(new Date(accountBadgeData.issuedAt), 'yyyy-MM-dd'),
        dcfRevisionNumber: (options.issuanceNo && options.issuanceNo > 0 ? options.issuanceNo : 1).toString(36).padStart(3, '0'),
        dcgCountry: 'United States of America',
        dcsLastName: account.lastName,
        dctFirstAndMiddleName: account.firstName,
        zceAffiliation: 'Volunteer', // always "Volunteer" in RMS (meaning we don't store unit in RMS bar codes)
        zclAccessLevel: undefined,
        zctOccupationTitle: undefined,
    };
}
